import { useEffect } from "react";

const UPNIFY_SCRIPT_ID = "upnifyWAOS";
const UPNIFY_SRC =
  "https://suite.upnify.com/addons/js/suite.min.js?tke=E-7885D3CA-905C-497E-AB7E-584463918E75&tki=P070F5D640C-A4FD-4BB4-8D2B-280C10B1E73A";

export const UpnifyAssistant = () => {
  useEffect(() => {
    // Evitar cargar el script más de una vez
    if (document.getElementById(UPNIFY_SCRIPT_ID)) return;

    const script = document.createElement("script");
    script.id = UPNIFY_SCRIPT_ID;
    script.src = UPNIFY_SRC;
    script.defer = true;

    // document.head.appendChild(script);

    return () => {
      // Normalmente NO se elimina para que el chat persista
      // Si lo quieres eliminar al salir de la página, descomenta:
      // document.getElementById(UPNIFY_SCRIPT_ID)?.remove();
    };
  }, []);

  return null;
};
